.listItem {
  padding-left: 0.75rem;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.bullet {
  color: #00D26A;
  margin-top: 2px;
  flex-shrink: 0;
}

.paragraph {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
